export const skillsData = [
    {
        category: 'Languages',
        items: ['Python', 'TypeScript', 'JavaScript', 'Java', 'SQL'],
    },
    {
        category: 'Backend & architecture',
        items: ['Django REST Framework', 'Node.js', 'Express.js', 'Laravel', 'Microservices'],
    },
    {
        category: 'Frontend',
        items: ['React.js', 'Next.js', 'Tailwind CSS', 'Material-UI (MUI)', 'Bootstrap'],
    },
    {
        category: 'Databases & messaging',
        items: ['PostgreSQL', 'MySQL', 'MongoDB', 'Redis pub/sub'],
    },
    {
        category: 'AI & computer vision',
        items: ['Computer Vision', 'Machine Learning', 'Deep Learning', 'LLM integration (RAG, LangChain, OpenAI API)'],
    },
    {
        category: 'Infrastructure & tooling',
        items: ['Docker', 'Kubernetes', 'Git', 'Postman', 'Swagger'],
    },
]

// Words to look for when a visitor asks "where did you use this?". Anything not
// listed is searched for by its own name. Matching is whole-word and
// case-insensitive, so "Java" never matches "JavaScript".
export const skillAliases = {
    'Django REST Framework': ['django rest framework', 'django'],
    'Express.js': ['express.js', 'express'],
    'React.js': ['react'],
    'Material-UI (MUI)': ['material-ui', 'mui'],
    'Tailwind CSS': ['tailwind'],
    'SQL': ['sql', 'postgresql', 'mysql'],
    'Redis pub/sub': ['redis'],
    'Microservices': ['microservice', 'microservices'],
    'LLM integration (RAG, LangChain, OpenAI API)': ['rag', 'langchain', 'openai', 'llm'],
}
